<template>
    <div class="sidebar seismic">
        <router-link v-if="design && design.id" :to="{ name: 'seismic-brace-summary', params: {id: design.id}}">
            <h5 class="summary">Seismic Summary</h5>
        </router-link>

        <h5 class="summary" v-else>Seismic Summary</h5>
        <div>
            <div>
                <router-link v-if="design && design.id" :to="{ name: 'seismic-setup', params: {id: design.id}}">
                    <h5><span>1</span> Seismic Project Setup</i></h5>
                </router-link>
                <h5 class="setup" v-else><span>1</span> Seismic Project Setup</h5>

                <ul v-if="design">
                    <li v-if="design.name">
                        <span>Submittal Name:</span>
                        <strong v-text="design.name"></strong>
                    </li>
                    <li v-if="design">
                        <span>Standard:</span>
                        <strong>2016 NFPA 13</strong>
                    </li>
                    <li v-if="design.listing">
                        <span>Agency:</span>
                        <strong v-text="util.translateListing(design.listing)"></strong>
                    </li>
                </ul>
            </div>
            <div>
                <router-link v-if="design && design.id && brace && brace.id" :to="{ name: 'seismic-brace-identify', params: {seismicDesignId: design.id, id: brace.id }}">
                    <h5><span>2</span> Finding Seismic Coefficient (Cp)</i></h5>
                </router-link>
                <h5 class="identify" v-else><span>2</span> Finding Seismic Coefficient (Cp)</h5>

                <ul v-if="brace">
                    <li v-if="brace.name">
                        <span>Brace Name:</span>
                        <strong v-text="brace.name"></strong>
                    </li>
                    <li v-if="brace.cp">
                        <span>Seismic Coefficient:</span>
                        <strong v-text="brace.cp"></strong>
                    </li>
                </ul>
            </div>
            <div>
                <router-link v-if="design && design.id && brace && brace.id && seismicDesignLoad" :to="{ name: 'seismic-brace-piping', params: {seismicDesignId: design.id, id: brace.id }}">
                    <h5><span>3</span> Define Brace Type and Piping System</i></h5>
                </router-link>
                <h5 class="system" v-else><span>3</span> Define Brace Type and Piping System</h5>

                <ul v-if="brace && seismicDesignLoad">
                    <li>
                        <span>Seismic Design Load:</span>
                        <strong v-text="lbOrKg(seismicDesignLoad, true, true)"></strong>
                    </li>
                </ul>
            </div>
            <div>
                <router-link v-if="design && design.id && brace && brace.id && seismicDesignLoad" :to="{ name: 'seismic-brace-attachment', params: {seismicDesignId: design.id, id: brace.id }}">
                    <h5><span>4</span> Define Structure and Pipe Attachments</i></h5>
                </router-link>
                <h5 class="attachment" v-else><span>4</span> Define Structure and Pipe Attachments</h5>
                <ul>
                    <li></li>
                </ul>
            </div>
        </div>
        <!--
        <div>
            <h3>Project</h3>
            <h5>Riverwalk Project</h5>
            <ul>
                <li class="document">
                    General Product Submittal
                </li>
                <li class="document">
                    Seismic Design Submittal
                </li>
            </ul>
        </div>
        -->
    </div>
</template>

<script>
    import util from './util.js';
    import { mapGetters, mapState } from 'vuex';

    export default {
        name: 'seismic-sidebar',

        props: [
            'design',
            'brace',
        ],

        computed: {
            util() {
                return util;
            },

            ...mapState({
                'seismicDesignLoad': state => state.seismicSystem.zoiSeismicDesignLoad,
            }),
        },
        mounted() {
            // var $height = $('.sidebar').outerHeight() + 200;
            // $('aside.primary .sidebar').fix({
            //     until: 'footer.primary',
            //     stopEarly: $height
            // });
        }
    }
</script>
